<template>
  <div>
    <el-popover
      ref="popver-notification"
      v-model="show"
      placement="bottom"
      trigger="click"
      @show="onOpen"
    >
      <div slot="reference" class="nav-downloads-wrapper">
        <!-- <span style="margin-right:5px;">Notification</span> -->
        <el-badge :value="$store.getters.unreadNotificaionCount" :hidden="$store.getters.unreadNotificaionCount === 0" class="bell-num">
          <i class=" el-icon-bell" style="font-weight: bolder; font-size: 18px;color: #4b5567;" />
        </el-badge>

        <i class="el-icon-caret-bottom icon-arrow-down" />
      </div>
      <div v-if="loading" class="loading-container">
        <i class="el-icon-loading" />
      </div>
      <div v-else-if="list.length <= 0" class="empty-container">
        <div class="empty-content">
          <img src="@/assets/img/notification_empty.png" style="width: 50px;" alt="">
          <div class="empty-tip">
            {{ $t('no_auth.no_notification') }}
          </div>
        </div>
        <div class="view-more " @click="onClickViewMoreTxt">
          {{ $t('no_auth.view_all') }}
        </div>
      </div>
      <template v-else>
        <div class="nav-notification-list">
          <div
            v-for="(item,index) in list"
            :key="item.user_detail_no"
            class="nav-notification-item"
            :class="{
              'padding-top-0': index === 0,
              'padding-bottom-0': index === (list.length-1),
            }"
            @click="onClickNotificatonItem(item)"
          >
            <div class="nav-notification-icon-container">
              <el-badge :is-dot="item.user_read_status === 1">
                <img src="@/assets/img/message_time.png" style="width: 32px;height: 32px;">
              </el-badge>

            </div>
            <div>

              <div class="nav-notification-name">{{ item.title }}</div>
              <div class="nav-notification-status"><span class="limit-length">{{ item.user_detail_no }}</span>

              </div>
            </div>
            <div v-if="item.notice_actual_time" class="nav-notification-time"><span>{{ item.notice_actual_time.split(' ') [0] }}</span><br><span style="text-align: right;">{{ item.notice_actual_time.split(' ') [1] }}</span></div>
          </div>
        </div>
        <div class="view-more " @click="onClickViewMoreTxt">
          {{ $t('no_auth.view_all') }}
        </div>
      </template>

    </el-popover>
    <Notification ref="notification" />
  </div>

</template>

<script>
import { fetchNotificationPage } from '@/api/system/system'
export default {
  name: 'MessageManage',
  components: {
    Notification: () => import('./NotificationModal.vue')
  },
  data() {
    return {
      list: [],
      show: false,
      loading: false
    }
  },
  // watch: {
  //   '$store.getters.unreadNotificaionCount': {
  //     handler: function(newVal) {
  //       if (newVal) {
  //         this.getMessageList()
  //       }
  //     }
  //   }
  // },
  methods: {
    onOpen() {
      this.getMessageList()
      this.$store.dispatch('user/getUnreadNotificationCount')
    },
    onClickNotificatonItem(item) {
      this.$refs.notification.showModal(item)
    },
    getMessageList() {
      this.loading = true
      const data = {}
      fetchNotificationPage(data).then(res => {
        if (res.code === 10000) {
          this.list = res.data || []
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onClickViewMoreTxt() {
      this.$router.push({ name: 'Notifications' })
    }
  }
}
</script>
<style scoped lang="scss">
.nav-downloads-wrapper{
  display: flex;
  align-items: center;
  color: #364250;
  color: #7A869E;
  font-size: 12px;
  // line-height: 1;
  cursor: pointer;
}
.bell-num ::v-deep .el-badge__content.is-fixed{
 top: 15px;
 display: flex;
 justify-content: center;
 align-items: center
}
.nav-downloads-container{
  display: inline-block;

}
.icon-arrow-down{
  position: relative;
  margin-left: 12px;;
  font-size: 12px;
  font-weight: bold;
  color: #4b5567;
  top: -2.5px;
}
.nav-file-notification{
  color: #4b5567;
  font-size: 18px;
}
.nav-notification-list{
  max-height: 400px;
  overflow-y: auto;
}
.nav-notification-item{
  display: flex;
  align-items: center;
  padding: 10px 0;
  font-size: 12px;
  color: #000;
  cursor: pointer;
}

.border-1{
  border-bottom: 1px solid #EDEDED;
}
.nav-notification-icon-container{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  .dropdown-file-notification{
    font-weight: 700;
    font-size: 19px;
    color: #fff
  }
}
.nav-notification-name{
  font-weight: 600;
  line-height: 1.5;
  padding-top: 5px;
  width: 200px;
  text-overflow: ellipsis;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
}

.padding-top-0{
  padding-top: 0;
}
.padding-bottom-0{
  padding-bottom: 0;
}
.nav-notification-status{
  font-weight: 400;

}
.limit-length{
  max-width: 220px;
  text-overflow: ellipsis;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
}
.nav-notification-time{
  margin-left: 20px;
  color: #AAA;
  font-size: 12px;
  text-align: right;
}

.color-blue{
  color: #3855F1;
  font-weight: bold;
  cursor: pointer;
}
.color-1d3a41{
  color: #1D3A71;
  font-weight: bold;
}
.color-aaa{
  color: #dd6161;
  font-weight: bold;
}
.empty-container{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 280px;
  min-height: 250px;
  box-sizing: border-box;
  .empty-content{
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .empty-tip{
    margin-top: 10px;
    color: #C9C9C9;
    font-size: 15px;
  }
  .view-more{
    margin-top: auto;
  }
}

.view-more{
  padding: 20px 20px 10px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  color: #3855F1;
  cursor: pointer;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 280px;
  min-height: 250px;
  font-size: 24px;
  color: #C9C9C9;
  i {
    animation: rotating 2s linear infinite;
  }
}
@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

</style>
